export const AUTH_SOURCE = Object.freeze({
    SIGN_UP: 'sign-up',
    SIGN_IN: 'sign-in',
    CHECKOUT_GUEST: 'checkout_guest',
    APPOINTMENT_BOOKED_GUEST: 'appointment_booked_guest'
});

export const COMMUNICATION_TYPE = Object.freeze({
    EMAIL: 'email'
});

export const SUBSCRIBE_SOURCE = 'subscribeSource';
export const UNSUBSCRIBE_SOURCE = 'unsubscribeSource';
export const COOKIE_USER_EMAIL = 'elc-user-email';
